import React, { FunctionComponent } from 'react'
import * as SC from 'components/TailwindUIToolkit/StyledComponents'

type NonEditModePropTypes = {
  content: JSX.Element | string
  primary?: boolean
}

const NonEditMode: FunctionComponent<React.PropsWithChildren<NonEditModePropTypes>> = ({
  content,
  primary = false
}) => {
  return (
    <SC.DetailsText>
      {content}
      {primary ? <SC.PrimaryStar /> : null}
    </SC.DetailsText>
  )
}

export default NonEditMode
